import * as React from "react";
import { style } from "typestyle";

interface IProps {
  size: number;
  color?: string;
  rotation?: number;
}

export const ListviewIcon = (props: IProps) => {
  const className = style({
    width: props.size,
    height: props.size,
    stroke: props.color,
    transform: `rotate(${props.rotation}deg)`
  });
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 38.75 26"
        className={className}
      >
        <path
          d="M4.63,12H43.38M4.63,24H43.38M4.63,36H43.38"
          transform="translate(-4.63 -11)"
          fill="none"
          strokeMiterlimit="10"
          strokeWidth="3"
        />
      </svg>
    </React.Fragment>
  );
};
